import { DataServiceCore } from './core';
import { withCompanies } from './entities/companies';
import { withUsers } from './entities/users';
import { withProjects } from './entities/projects';
import { withTasks } from './entities/tasks';
import { withProjectPlanner } from './entities/projectPlanner';
import { withNotifications } from './entities/notifications';
import { withFinance } from './entities/finance';
import { withCrm } from './entities/crm';
import { withActivities } from './entities/activities';
import { withDocuments } from './entities/documents';
import { withUtils } from './entities/utils';
import { withClaims } from './entities/claims';
import { withAnalytics } from './entities/analytics';
import { withSupervisor } from './entities/supervisor';

const DataServiceMixins = withSupervisor(
  withAnalytics(
    withClaims(
      withUtils(
        withDocuments(
          withActivities(
            withCrm(
              withFinance(
                withNotifications(
                  withTasks(
                    withProjectPlanner(
                      withProjects(
                        withUsers(
                          withCompanies(DataServiceCore as any)
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);

export class DataServiceEntities extends DataServiceMixins {}
